export const allowedCountries = ['DK', 'NO', 'SE', 'FI']
